import { apiLink } from '../../constants/env';
import axiosInstance from '../AxiosInstance';

const apiArComprimido = {
    fetchApi: async (page) => {
        const URL = `${apiLink()}api/ar-comprimido?page=` + page;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    getById: async (id) => {
        const URL = `${apiLink()}api/ar-comprimido/` + id;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    postApi: async (arComprimido) => {
        const URL = `${apiLink()}api/ar-comprimido`;
        return await axiosInstance.post(URL, arComprimido)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    deleteApi: async (id) => {
        const URL = `${apiLink()}api/ar-comprimido/status/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    putApi: async (id, arComprimido) => {
        const URL = `${apiLink()}api/ar-comprimido/${id}`;
        return await axiosInstance.put(URL, arComprimido)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    getByRegimeId: async (id) => {
        const URL = `${apiLink()}api/ar-comprimido/regime/${id}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar dados do arComprimido:', error);
                throw new Error();
            })
    },
    getByUnidadeId: async (id) => {
        const URL = `${apiLink()}api/ar-comprimido/all`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar dados do arComprimido:', error);
                throw new Error();
            })
    },
    getEquipamentoComUltimasLeituras: async (equipamentoId, numLeituras) => {
        const URL = `${apiLink()}api/ar-comprimido/${equipamentoId}/numero-leituras/${numLeituras}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar arComprimido:', error);
                throw new Error('Erro ao pegar arComprimido:', error);
            })
    },
    getarComprimidosTuneis: async (unidadeId) => {
        const URL = `${apiLink()}api/ar-comprimido/tuneis`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao pegar arComprimido:', error);
                throw new Error('Erro ao pegar arComprimido:', error);
            })
    }
}

export default apiArComprimido; 